import * as React from 'react';

import { Col, Divider, Row, theme } from 'antd';

import { AppControls } from 'src/components/appControls';
import { NavLink } from 'react-router-dom';
import { css } from '@emotion/react';
import { useAppRoutes } from 'src/hooks';

const header: React.FC = (props) => {
    const appRoutes = useAppRoutes();
    const antdTheme = theme.useToken().token;

    return (
        <Row
            className="header"
            justify="space-between"
            align="middle"
            style={{
                zIndex: 9,
                height: '100%',
                width: '100%',
                minWidth: '350px',
                margin: 0,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: antdTheme.colorBgContainer,
            }}
            css={css({
                // Hide drawer menu button
                '.header-menu-button': {
                    display: 'none',
                },
                // When we're on a small screen (<=767px), hide the menu in the header and show the drawer menu button
                '@media all and (max-width: 767px)': {
                    '.header-menu-button': {
                        display: 'block',
                    },
                    '.app-menu-container, .menu-item-link, .sub-menu': {
                        display: 'none',
                    },
                },
            })}
        >
            <Col>
                <Row
                    align="middle"
                    justify="start"
                >
                    <Col>
                        <NavLink
                            to={appRoutes.home.path}
                        >
                            <Row>
                                <div
                                    className="header-title"
                                    style={{
                                        // flex: 0,
                                        alignSelf: 'middle',
                                        marginLeft: 10,
                                        marginRight: 10,
                                        color: antdTheme.colorTextHeading,
                                        fontSize: '25px',
                                    }}
                                >
                                    <span
                                        style={{
                                            fontWeight: 'lighter',
                                        }}
                                    >
                                        Linamar
                                        {/* <span
                                            style={{
                                                color: antdTheme.colorPrimary,
                                            }}
                                        >
                                            Exit
                                        </span> */}
                                    </span>

                                    <Divider type="vertical" />

                                    <span
                                        style={{
                                            fontWeight: 'bold',
                                            color: antdTheme.colorPrimary,
                                            position: 'relative',
                                            top: '-0.10em',
                                            fontSize: '60%',
                                        }}
                                    >
                                        Exit Interview
                                    </span>
                                </div>
                            </Row>
                        </NavLink>
                    </Col>
                </Row>
            </Col>

            <Col>
                <AppControls />
            </Col>
        </Row>
    );
};

export const Header = React.memo(header);